__webpack_require__.p = "/ball-mini-portfolio/";